// extracted by mini-css-extract-plugin
export default {"headerText":"GoogleForm_headerText__+CJ89"};